<template>
  <el-dialog
    :title="$t('CargoMsg.Cargo_FormValidation')"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    class="validation-dialog"
  >
    <!-- 顶部状态区域 -->
    <div class="validation-status">
      <div v-if="hasError" class="error-status">
        <div class="status-icon error-icon">
          <i class="el-icon-close" />
        </div>
        <span class="status-text">{{ $t('CargoMsg.Cargo_ValidationFailed') }}</span>
      </div>
      <div v-else class="success-status">
        <div class="status-icon success-icon">
          <i class="el-icon-check" />
        </div>
        <span class="status-text">{{ $t('CargoMsg.Cargo_ValidationSucceed') }}</span>
      </div>
    </div>

    <!-- 错误列表区域 -->
    <div v-if="hasError" class="error-list">
      <el-table
        :data="errorList"
        style="width: 100%"
        :show-header="true"
        border
      >
        <el-table-column
          prop="fieldName"
          :label="$t('CargoMsg.Cargo_Problem')"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.isGlobalError ? '' : getFieldLabel(scope.row.fieldName) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="message"
          :label="$t('CargoMsg.Cargo_Description')"
        >
          <template slot-scope="scope">
            {{ getErrorMessage(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 底部按钮区域 -->
    <div class="dialog-footer">
      <el-button @click="handleClose">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLocalizedName } from '@/utils/langUtil'

export default {
  name: 'AiCustomPageDataValidation',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    validationResult: {
      type: Object,
      default: () => ({})
    },
    pageParts: {
      type: Array,
      required: true
    }
  },
  computed: {
    hasError() {
      if (!this.validationResult?.data?.jobList?.[0]) {
        return false
      }
      const job = this.validationResult.data.jobList[0]
      return job.messageKey || job.validFields?.some(field => field.canNotUpdate)
    },
    errorList() {
      if (!this.hasError) return []
      const job = this.validationResult.data.jobList[0]
      const errors = []

      // 先处理全局错误
      if (job.messageKey) {
        errors.push({
          fieldName: '',
          messageKey: job.messageKey,
          messageZhCn: job.messageZhCn
        })
      }

      // 再处理字段级错误
      if (job.validFields) {
        errors.push(...job.validFields
          .filter(field => field.canNotUpdate)
          .map(field => ({
            fieldName: field.filed,
            messageKey: field.messageKey,
            messageZhCn: field.messageZhCn
          })))
      }

      return errors
    }
  },
  methods: {
    getFieldLabel(fieldName) {
      if (!fieldName) return ''
      // 提单字段前缀
      const blPrefix = 'doc_'
      if (fieldName.startsWith(blPrefix)) {
        fieldName = fieldName.slice(blPrefix.length)
      }

      // 从pageParts中查找对应的元素
      for (const pagePart of this.pageParts) {
        const element = pagePart.elements?.find(el => el.elementName === fieldName)
        if (element) {
          return `${getLocalizedName(element)} (${fieldName})`
        }
      }
      return `${this.$t('CargoMsg.Cargo_Unknown')} (${fieldName})`
    },
    getErrorMessage(error) {
      if (error.messageKey) {
        const translated = this.$t(error.messageKey)
        if (translated !== error.messageKey) {
          return translated
        }
      }
      return error.messageZhCn || error.messageKey || ''
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.validation-dialog {
  :deep(.el-dialog__wrapper) {
    z-index: 3000 !important;
  }

  .validation-status {
    text-align: center;
    padding: 20px 0;

    .status-icon {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 16px;

      i {
        font-size: 32px;
        color: white;
      }
    }

    .error-icon {
      background-color: #F56C6C;
    }

    .success-icon {
      background-color: #67C23A;
    }

    .status-text {
      display: block;
      font-size: 16px;
      color: #606266;
    }
  }

  .error-list {
    margin: 20px 0;
  }

  .dialog-footer {
    text-align: right;
    padding-top: 20px;
  }
}
</style>
